import { useCallback, useEffect } from "react";
import useTrackerContext from "../useTrackerContext.js";
import useUserAgent from "../useUserAgent.js";
import useGlobalContext from "../useGlobalContext.js";
import useIsInViewport from "../useIsInViewport.js";
import useRouteName from "../useRouteName.js";
import { getExtOriginMarketingTrackingVariable } from "../../utils/marketing-url-params.js";
const ACTION_NAME = "flights__landing_page_events";
const ACTION_VERSION = "2.0.0";
const LANDING_PAGE_NAME = "flights-index";
const types = ["click", "scroll_to", "page_view"];
const components = [
    "popular_flights_domestic",
    "popular_flights_international",
    "popular_flights_nearby",
    "popular_flights",
    "faq",
    "whole_page",
    "worldwide_flights",
    "homepage",
    "searchbox",
    "flights_interlinking"
];
const useLandingPageEvents = () => {
    const { trackExternal } = useTrackerContext();
    const { isMobile } = useUserAgent();
    const { analyticSessionId, isPPC, marketingTrackingVariables, uvi } = useGlobalContext();
    return useCallback((type, component, componentData) => {
        const trackingData = {
            analyticSessionId,
            isMobile,
            isPPC,
            marketingTrackingVariables,
            uvi
        };
        if (!types.includes(type) || !components.includes(component)) {
            return;
        }
        trackExternal({
            type: "c360",
            args: [
                {
                    action_name: ACTION_NAME,
                    action_version: ACTION_VERSION,
                    content: getContent(type, component, trackingData, componentData)
                }
            ]
        });
    }, [analyticSessionId, isMobile, isPPC, marketingTrackingVariables, trackExternal, uvi]);
};
const getContent = (type, component, trackingData, componentData) => {
    const channel = (trackingData.isPPC ? "ppc" : getExtOriginMarketingTrackingVariable()) ?? "direct";
    const urlParams = new URLSearchParams(componentData?.url.split("?")[1]);
    const label = urlParams.get("label") || "";
    return {
        session_id: trackingData.analyticSessionId || "",
        uvi: trackingData.uvi || "",
        aid: trackingData.marketingTrackingVariables?.aid || "",
        platform: trackingData.isMobile ? "Mobile" : "Desktop",
        action_type: type,
        landing_page_name: LANDING_PAGE_NAME,
        channel,
        data: {
            component,
            position: componentData?.position,
            label,
            from_city_iata: componentData?.fromCityIata || "",
            to_city_iata: componentData?.fromCityIata || "",
            from_airport_name: componentData?.toCityIata || "",
            to_city_name_localised: componentData?.toCityNameLocalised || "",
            to_country_code: componentData?.toCountryCode || "",
            trip_start_date: componentData?.tripStartDate || "",
            trip_end_date: componentData?.tripEndDate || ""
        }
    };
};
export const useTrackLandingPageViewport = (elementRef, component) => {
    const trackLandingPageEvents = useLandingPageEvents();
    const routeName = useRouteName();
    const { isMobile } = useUserAgent();
    const isInViewport = useIsInViewport(elementRef, [], {
        threshold: 0.75
    });
    useEffect(() => {
        if (component === "whole_page" && routeName !== "home")
            return;
        if (isInViewport) {
            trackLandingPageEvents("scroll_to", component);
        }
    }, [isInViewport, component, trackLandingPageEvents, routeName, isMobile]);
};
export default useLandingPageEvents;
